import { render, staticRenderFns } from "./washing.vue?vue&type=template&id=a870ebd2&scoped=true&"
import script from "./washing.vue?vue&type=script&lang=js&"
export * from "./washing.vue?vue&type=script&lang=js&"
import style0 from "./washing.vue?vue&type=style&index=0&id=a870ebd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a870ebd2",
  null
  
)

export default component.exports